import shifts from './shiftsReducer';
import shiftConfig from './shiftConfigReducer';
import patients from './patientsReducer';
import appointments from './appointmentsReducer';

export { shifts, shiftConfig, patients, appointments };
